import React, { useRef } from 'react';
import { Upload, X, FileText } from 'lucide-react';
interface FileUploadProps {
  label?: string;
  value?: File;
  onChange: (file: File | undefined) => void;
  error?: string;
  accept?: string;
}
export function FileUpload({
  label,
  value,
  onChange,
  error,
  accept
}: FileUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    onChange(file);
  };
  const handleRemove = () => {
    onChange(undefined);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  return <div className="w-full" data-id="element-251">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-252">
          {label}
        </label>}
      {!value ? <div onClick={() => inputRef.current?.click()} className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors hover:border-blue-400 hover:bg-blue-50 ${error ? 'border-red-500' : 'border-gray-300'}`} data-id="element-253">
          <Upload className="w-8 h-8 mx-auto mb-2 text-gray-400" data-id="element-254" />
          <p className="text-sm text-gray-600" data-id="element-255">Click to upload file</p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-256">or drag and drop</p>
        </div> : <div className="flex items-center gap-3 p-3 border border-gray-300 rounded-lg" data-id="element-257">
          <FileText className="w-5 h-5 text-gray-400" data-id="element-258" />
          <span className="text-sm text-gray-900 flex-1" data-id="element-259">{value.name}</span>
          <button onClick={handleRemove} className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-260">
            <X className="w-5 h-5" data-id="element-261" />
          </button>
        </div>}
      <input ref={inputRef} type="file" onChange={handleFileChange} accept={accept} className="hidden" data-id="element-262" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-263">{error}</p>}
    </div>;
}